import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SidebarContextType {
  isSideBarOpen: boolean;
  setIsSideBarOpen: (open: boolean) => void;
}

interface SidebarNavItemCollapseContextType {
  currentMenuActive: string | null;
  setCurrentMenuActive: (id: string | null) => void;
}

interface PartnerContextType {
  selectedPartner: string;
  setSelectedPartner: (partnerId: string) => void;
  partnerData: any;
}

export const SidebarContext = createContext<SidebarContextType | undefined>(undefined);
export const SidebarNavItemCollapseContext = createContext<SidebarNavItemCollapseContextType | undefined>(undefined);
export const PartnerContext = createContext<PartnerContextType | undefined>(undefined);

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (context === undefined) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};

export const useSidebarNavItemCollapse = () => {
  const context = useContext(SidebarNavItemCollapseContext);
  if (context === undefined) {
    throw new Error('useSidebarNavItemCollapse must be used within a SidebarNavItemCollapseProvider');
  }
  return context;
};

export const usePartner = () => {
  const context = useContext(PartnerContext);
  if (context === undefined) {
    throw new Error('usePartner must be used within a PartnerProvider');
  }
  return context;
};

interface SidebarProviderProps {
  children: ReactNode;
}

export const SidebarProvider: React.FC<SidebarProviderProps> = ({ children }) => {
  const [isSideBarOpen, setIsSideBarOpen] = useState(true);
  const [currentMenuActive, setCurrentMenuActive] = useState<string | null>(null);
  const [selectedPartner, setSelectedPartner] = useState('');

  // Mock partner data - you can replace this with actual data from your API
  const partnerData = {
    '1': { name: 'Spire Studio', logo: 'S', avatar: 'S', role: 'Studio Manager' },
    '2': { name: 'RapidWorks', logo: 'R', avatar: 'R', role: 'Project Manager' },
    '3': { name: 'Contractor Pro', logo: 'C', avatar: 'C', role: 'Contractor' },
  };

  return (
    <SidebarContext.Provider value={{ isSideBarOpen, setIsSideBarOpen }}>
      <SidebarNavItemCollapseContext.Provider value={{ currentMenuActive, setCurrentMenuActive }}>
        <PartnerContext.Provider value={{ selectedPartner, setSelectedPartner, partnerData }}>{children}</PartnerContext.Provider>
      </SidebarNavItemCollapseContext.Provider>
    </SidebarContext.Provider>
  );
};
